// extracted by mini-css-extract-plugin
module.exports = {"SocialLinks":"SocialLinks__2S5BO","SocialLinks___hide":"SocialLinks___hide__2S5BO","SocialLinks_item":"SocialLinks_item__2S5BO","SocialLinks_link":"SocialLinks_link__2S5BO"};